import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { Permission } from '../types/api';

export const usePermissions = () => {
  const { currentHospitalRoles } = useSelector(
    (state: RootState) => state.user,
  );

  const hasPermission = (permission: Permission): boolean => {
    if (!currentHospitalRoles) {
      return false;
    }

    return currentHospitalRoles.permissions.includes(permission);
  };

  const hasAnyPermission = (permissions: Permission[]): boolean => {
    return permissions.some((permission) => hasPermission(permission));
  };

  const hasAllPermissions = (permissions: Permission[]): boolean => {
    return permissions.every((permission) => hasPermission(permission));
  };

  const getCurrentRoles = (): string[] => {
    return currentHospitalRoles?.roles || [];
  };

  const getCurrentPermissions = (): string[] => {
    return currentHospitalRoles?.permissions || [];
  };

  const isAdmin = (): boolean => {
    return currentHospitalRoles?.roles.includes('ADMIN') || false;
  };

  const canManageUsers = (): boolean => {
    return hasAnyPermission(['read-user', 'write-user', 'delete-user']);
  };

  const canManageRules = (): boolean => {
    return hasAnyPermission(['read-rule', 'write-rule', 'delete-rule']);
  };

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    getCurrentRoles,
    getCurrentPermissions,
    isAdmin,
    canManageUsers,
    canManageRules,
    currentHospitalRoles,
  };
};
